import router from '@/router';
import { ref } from 'vue';

const currentRoute = ref(undefined);
function pushToRouter(meta) {
  router.push(meta);
}

router.afterEach((to) => {
  currentRoute.value = to;
});

export const useRoute = () => {
  return {
    currentRoute,
    pushToRouter
  };
};
